

export default function setImageAction(image) {
    return {
        type: 'SET_IMAGE',
        payload: image
    }
}